// extracted by mini-css-extract-plugin
export default {"bundle_group_content":"BundleWebGroup_bundle_group_content__G-4XX","white_border":"BundleWebGroup_white_border__uYTDA"};